// 1. timestamp : timestamp
// 2. option : string ("all" || "date")

const timestampCalculator = (timestamp, option = "all") => {

    const utcDate = new Date(timestamp)
    utcDate.setHours(utcDate.getHours())

    if (option === "all")
        return utcDate.toLocaleString()
    else if (option === "date")
        return utcDate.toLocaleDateString()

    return ""
}

export default timestampCalculator